import { render, staticRenderFns } from "./EditBusinessForm.vue?vue&type=template&id=8bd820f0&"
import script from "./EditBusinessForm.vue?vue&type=script&lang=js&"
export * from "./EditBusinessForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports